var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 669.035,
    height: 412.328,
    viewBox: "0 0 669.035 412.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.22;}.b{fill:#a2dbf1;}.c{opacity:0.3;}.d{fill:#222221;}.e{fill:#b3b3b3;}.f{fill:#3e3e3d;}.g{fill:#6f6f6f;}.h{fill:#fff;}.i,.l{fill:none;stroke:#425973;stroke-linecap:round;stroke-linejoin:round;}.i{stroke-width:3.3px;}.j{fill:#dd9ab2;}.k{fill:#d6819f;}.l{stroke-width:2.75px;}.m{fill:#e9c2c2;}.n{fill:#dd6435;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-65.679 -42.21)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(70.039 68.582)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M423.664,91.324c-69.357,22.133-289.037-87.042-271.848,62.021,2.694,22.186,16.976,53.5,4.909,74.213-8.736,15.505-24.809,24.6-40.243,30.621-40.42,16.427-55.465,47.278-45.24,91.3,27.4,118.638,176.459,90.5,254.73,55.323,55.66-26.173,121.3-30.674,178.976-8.523C550.1,414.3,578.239,452.128,631.24,441.053c46.994-9.445,54.083-53.8,40.367-95.105-7.8-25.553-13.4-36.362,2.056-61.011,13.042-24.507,35.972-43.06,37.744-71.767.372-31.082-13.911-62.393-41.537-74.177-22.629-9.622-43.131-5.741-65.565-11.66C554.547,113.35,522.561,36.019,460.77,62.617c-15.381,7.265-24.047,24.011-40.757,28.884",
    transform: "translate(-68.139 -57.092)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(65.679 42.21)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M256.635,74.646c6.291,0,6.291-9.746,0-9.746S250.345,74.646,256.635,74.646Z",
    transform: "translate(78.104 -24.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.748,163.492c12.581,0,12.581-19.492,0-19.492S83.184,163.492,95.748,163.492Z",
    transform: "translate(-49.744 36.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M426.435,207.312c12.564,0,12.564-19.492,0-19.492S413.872,207.312,426.435,207.312Z",
    transform: "translate(205.564 70.206)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M240.108,76.142c12.564,0,12.564-19.492,0-19.492S227.527,76.142,240.108,76.142Z",
    transform: "translate(61.707 -31.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M438.669,192.4c16.338,0,16.338-25.34,0-25.34S422.331,192.4,438.669,192.4Z",
    transform: "translate(212.823 54.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M78.419,184.15c16.338,0,16.338-25.34,0-25.34S62.08,184.15,78.419,184.15Z",
    transform: "translate(-65.303 47.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M383.669,98.21c16.338,0,16.338-25.34,0-25.34S367.33,98.21,383.669,98.21Z",
    transform: "translate(170.361 -18.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M257.991,71.449c18.854,0,18.854-29.239,0-29.239S239.136,71.449,257.991,71.449Z",
    transform: "translate(71.876 -42.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M442.32,200.649c9.427,0,9.427-14.619,0-14.619S432.893,200.649,442.32,200.649Z",
    transform: "translate(219.644 68.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.24,156.519c9.427,0,9.427-14.619,0-14.619S64.813,156.519,74.24,156.519Z",
    transform: "translate(-64.527 34.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M398.6,101.519c9.427,0,9.427-14.619,0-14.619S389.173,101.519,398.6,101.519Z",
    transform: "translate(185.89 -7.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M396.193,84.246c6.291,0,6.291-9.746,0-9.746S389.92,84.246,396.193,84.246Z",
    transform: "translate(185.853 -17.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M119.678,79.022c12.564,0,12.564-19.492,0-19.492S107.1,79.022,119.678,79.022Z",
    transform: "translate(-31.269 -28.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M432.628,268.642c12.564,0,12.564-19.492,0-19.492S420.047,268.642,432.628,268.642Z",
    transform: "translate(210.34 117.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.108,273.492c12.564,0,12.564-19.492,0-19.492S62.527,273.492,75.108,273.492Z",
    transform: "translate(-65.679 121.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M134.126,66.526c6.291,0,6.291-9.746,0-9.746S127.835,66.526,134.126,66.526Z",
    transform: "translate(-16.478 -30.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M431.263,242.4c6.273,0,6.273-9.746,0-9.746S424.972,242.4,431.263,242.4Z",
    transform: "translate(212.928 104.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M89.573,276.086c6.273,0,6.273-9.746,0-9.746S83.282,276.086,89.573,276.086Z",
    transform: "translate(-50.869 130.827)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M204.089,210.318c-6.557,2.321-10.9,2.764-14.265-3.881-2.587-5.1-4.306-10.384-7.567-15.169-7.088-10.384-13.91-11.075-25.234-9.587s-26.581-1.418-28.353-14.407c-1.205-9.25-1.276-17.72-5.316-26.421-2-4.271-8.293-.549-6.308,3.686,4.5,9.622,2.534,20.077,5.812,29.859s14.46,13.131,23.8,14.176c7.088.851,13.255-.851,20.184-.851,7.425,0,12.511,12.759,14.867,18.358,4.909,11.678,11.873,15.594,24.259,11.217,4.412-1.559,2.516-8.63-1.949-7.088Z",
    transform: "translate(39.363 74.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M126.592,135.078a22.1,22.1,0,0,1-8.045,6.273c-3.367,1.683-.408,6.734,2.942,5.05a28.174,28.174,0,0,0,10.154-8.364,2.924,2.924,0,0,0-1.046-4,3.013,3.013,0,0,0-4,1.045Z",
    transform: "translate(39.67 70.603)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M116.53,131.344c0,6.184.921,12.4.975,18.518a2.924,2.924,0,1,0,5.848,0c0-6.184-.957-12.4-.975-18.518a2.924,2.924,0,0,0-5.848,0Z",
    transform: "translate(39.259 66.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M111.3,135.68c3.916,4.891,7.886,9.764,13.273,13.131,3.207,2,6.131-3.066,2.942-5.05-4.909-3.066-8.506-7.761-12.068-12.209-2.357-2.959-6.468,1.223-4.147,4.129Z",
    transform: "translate(34.69 68.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M108.572,140.55a19.032,19.032,0,0,0,19.492,4.643c3.544-1.1,2.056-6.734-1.559-5.635a13.078,13.078,0,0,1-13.716-3.136c-2.747-2.6-6.893,1.524-4.147,4.129Z",
    transform: "translate(32.474 72.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M337.953,221.152c.266-9.551,3.456-12.741,12.688-13.485a179.234,179.234,0,0,0,17.986-1.506c9.055-1.683,8.86-14.176,12.4-20.609,5.316-9.835,19.687-8.86,28.955-11.7,10.207-3.19,14.176-11.837,14.726-21.9.284-4.714-7.088-4.678-7.3,0-.9,14.974-11.873,15.505-23.94,17.986-10.632,2.18-17.827,8.01-21.53,18.252-1.152,3.207-1.435,9.888-5.316,10.916-6.184,1.648-13.308.9-19.67,1.595-11.943,1.294-16.072,9.108-16.374,20.449-.142,4.714,7.177,4.714,7.3,0Z",
    transform: "translate(204.513 82.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M374.041,146.939A23.037,23.037,0,0,0,386.8,159.7a2.924,2.924,0,0,0,3.544-2.038,3,3,0,0,0-2.038-3.544,16.516,16.516,0,0,1-8.683-8.683,3,3,0,0,0-3.544-2.038,2.924,2.924,0,0,0-2.038,3.544Z",
    transform: "translate(237.995 78.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M378.88,142.344v14.619a2.924,2.924,0,0,0,5.848,0V142.344a2.924,2.924,0,1,0-5.848,0Z",
    transform: "translate(241.803 75.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M388.8,142.584a27.041,27.041,0,0,1-9,12.4c-2.924,2.375,1.24,6.486,4.147,4.129a32.517,32.517,0,0,0,10.49-14.938c1.24-3.544-4.412-5.086-5.635-1.559Z",
    transform: "translate(241.74 75.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M394.07,145.789a22.5,22.5,0,0,1-10.933,8.4c-3.438,1.418-1.932,7.088,1.559,5.635a29.1,29.1,0,0,0,14.424-11.075C401.122,145.54,396.072,142.6,394.07,145.789Z",
    transform: "translate(243.589 78.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.2,276.091c0,5.1-38.294,6.592-42.423,6.592h-286.5c-4.129,0-42.423-1.488-42.423-6.592l34.945-52.364c0-5.121,3.349-9.268,7.478-9.268h286.5c4.129,0,7.478,4.147,7.478,9.268Z",
    transform: "translate(61.123 132.983)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M248.458,256.248H174.83l12.883-31.188h66.593Z",
    transform: "translate(84.269 141.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M285.428,256.248h73.628L346.173,225.06H279.58Z",
    transform: "translate(165.14 141.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M335.52,256.248h25.925L340.233,225.06H320.67Z",
    transform: "translate(196.863 141.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M181.5,256.248H155.58l21.229-31.188h19.546Z",
    transform: "translate(69.407 141.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M324.909,256.248H220.04l5.848-31.188h93.174Z",
    transform: "translate(119.173 141.167)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 320.526,
    height: 4.767,
    transform: "translate(231.384 371.915)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 327.472,
    height: 4.767,
    transform: "translate(227.911 383.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M519,262.133c0,4.147-.851,7.5-4.979,7.5H148.729c-4.129,0-4.979-3.349-4.979-7.5v-6.415c0-4.129.851-7.478,4.979-7.478H514.017c4.129,0,4.979,3.349,4.979,7.478Z",
    transform: "translate(60.274 159.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M347.933,256.068a3.9,3.9,0,0,1-3.9,3.9H214.888a3.9,3.9,0,0,1-3.9-3.9h0a3.916,3.916,0,0,1,3.9-3.9H344.035a3.916,3.916,0,0,1,3.9,3.9Z",
    transform: "translate(112.186 162.097)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 308.955,
    height: 206.761,
    rx: 4.23,
    transform: "translate(237.179 150.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M250.989,111.838a3.119,3.119,0,1,0-3.119-3.119,3.119,3.119,0,0,0,3.119,3.119Z",
    transform: "translate(140.658 48.939)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 265.699,
    height: 177.806,
    rx: 3.63,
    transform: "translate(258.798 166.199)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 22.044,
    y2: 22.044,
    transform: "translate(330.919 233.058)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 22.044,
    y1: 22.062,
    transform: "translate(330.919 233.058)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 22.044,
    y2: 22.044,
    transform: "translate(430.331 233.058)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 22.044,
    y1: 22.062,
    transform: "translate(430.331 233.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M286.951,177.37v21.778a7.8,7.8,0,0,1-7.8,7.8h-4.218a7.8,7.8,0,0,1-7.8-7.8V177.37",
    transform: "translate(155.535 104.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M277.64,178.01l-3.42,25.34-3.42-25.34Z",
    transform: "translate(158.361 104.843)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "l",
    x2: 132.158,
    transform: "translate(325.568 281.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M204.235,184.032c12.564,0,12.564-19.492,0-19.492S191.672,184.032,204.235,184.032Z",
    transform: "translate(99.696 94.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M303.235,184.032c12.564,0,12.564-19.492,0-19.492S290.672,184.032,303.235,184.032Z",
    transform: "translate(176.128 94.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M308.48,90.87v64.325c0,6.291,9.746,6.291,9.746,0V90.87C318.226,84.6,308.48,84.6,308.48,90.87Z",
    transform: "translate(187.451 33.935)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M314.31,145.519c9.427,0,9.427-14.619,0-14.619S304.883,145.519,314.31,145.519Z",
    transform: "translate(186.494 68.472)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.1f533f6c878044a8e3090329799a371c.svg";
export { ForwardRef as ReactComponent };